import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { RegionListDataService } from 'src/app/general/regions/list/region-list.data';
import { RegionEditorView } from './region-editor.view';

interface RegionEditorControllerProps {
	value: number | number[] | null;
	mode: ControlMode;
	onChanged: (value: any) => void;
	setBusy(isBusy: boolean);
	label?: string;
	multi?: boolean;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

export class RegionEditorController extends React.Component<RegionEditorControllerProps, any> {
	protected regionDataService: RegionListDataService;

	constructor(props) {
		super(props);
		this.regionDataService = RegionListDataService.make();
	}

	@autobind
	protected regionQuery(q?: string): Promise<QueryResult<RegionSummary>> {
		return new Promise<QueryResult<RegionSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.regionDataService.addFilter('isDeleted', 'eq', false);
			this.regionDataService.addSorting('code', 'asc', true);
			this.regionDataService.searchKeywords = q;
			this.regionDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.regionDataService.count
					});
				});
		});
	}

	render() {
		return (
			<RegionEditorView
				multi={this.props.multi}
				onGetErrorMessage={this.props.onGetErrorMessage}
				regionRequest={{ query: this.regionQuery, dataSet: this.regionDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
				afterLoad={this.props.afterLoad}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/regions/parts/region-editor.controller.tsx